"use client";

import { colors } from "@areahub/theme";
import { Flex, Heading } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { RichTextContent } from "@graphcms/rich-text-types";
import { Button, Button_T } from "@ui/components";
import { SectionTemplate } from "components/individuals/blocks";
import { customRichText } from "components/individuals/mdx-components";
import { ButtonProp, ImageFragment } from "lib/gcms";

export interface ClientSimpleChecklistSectionProps {
  title: string;
  textColor: string;
  bg: string;
  buttons: Omit<ButtonProp, "buttonAction" | "id">[];
  content?: {
    raw: RichTextContent;
  };
}

export const ClientSimpleChecklistSection = (
  props: ClientSimpleChecklistSectionProps,
) => {
  return (
    <SectionTemplate bg={props.bg} color={props.textColor}>
      <Heading
        as={"h1"}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        lineHeight={1.2}
        fontWeight={"bold"}
        mb={{
          base: 8,
          lg: 12,
        }}
        textAlign={"left"}
        w={{
          lg: "80%",
        }}
      >
        {props.title}
      </Heading>

      <RichText
        content={props.content?.raw as RichTextContent}
        renderers={customRichText(props.textColor, undefined, undefined, {
          base: 17,
          lg: 19,
          xl: 21,
        })}
      />

      <Flex
        justify={"center"}
        mt={{
          base: 8,
          md: 12,
        }}
      >
        {props.buttons.map((btn, index) => (
          <Button
            key={index}
            bgColor={colors.enterpriseColors.blue["300"]}
            color={"white"}
            fontSize={{
              base: 12,
              md: 14,
              lg: 16,
              xl: 18,
            }}
            fontWeight={"bold"}
            py={{
              base: "6",
              lg: "8",
            }}
            w={{
              base: "140px",
              md: "160px",
              lg: "180px",
              xl: "220px",
            }}
            textTransform={"uppercase"}
            {...(btn as Button_T)}
          />
        ))}
      </Flex>
    </SectionTemplate>
  );
};
